import { DockNavigationProvider } from "./DockNavigationContext";

export default function DockLayout({ children }) {
  return (
    <DockNavigationProvider value={{ activeTile: "home", openTile: () => {} }}>
      <div className="app-container">
        <div className="content-area" style={{ paddingBottom: 24 }}>
          {children}
        </div>
      </div>
    </DockNavigationProvider>
  );
}
